export const extConfig = {
    bold: false,
    italic: false,
    strikethrough: false,
    underline: false,
    bulletList: false,
    orderedList: false,
    horizontalRuler: false,
    link: true,
    emote: true,
    gif: false,
    deviation: false,
    deviationThumb: false,
    allowUploads: false,
    daVideo: false,
    gallery: false,
    anchor: false,
    spinner: false,
    blockDragging: false,
    blockquote: false,
    heading: false,
    hashtag: true,
    mention: false,
    paste: false,
    textAlignment: false,
    textColor: false,
    textFont: false,
    textHighlight: false,
    history: false,
    indent: {
        captureTab: false
    },
    muro: false,
    characterCount: true,
    singleLine: true
};

//# sourceMappingURL=config.js.map